const getAppBaseURL = () => {
  const { helpCenterURL } = window.chatwootConfig || {};
  return helpCenterURL || '';
};

export const buildAppUrl = (path, { accountId, accessToken } = {}) => {
  const baseURL = getAppBaseURL();
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const params = new URLSearchParams({
    accountId: String(accountId),
    accessToken: accessToken || '',
  });

  return `${baseURL}${normalizedPath}?${params.toString()}`;
};
